var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "18px",
    viewBox: "0 0 26 44",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "nonzero",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R_Reaktor",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 4.99769647 0 35.9744259 6.85512022 35.9744259 6.85512022 24.82452 10.1999998 24.82452 10.1999998 18.6207318 6.85512022 18.6207318 6.85512022 11.7658376 10.1999998 11.7700005 10.1999998 4.99769647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1219399,21.1910682 C20.775153,19.4012329 23.2605683,16.2733271 23.2605683,11.2629035 C23.2605683,4.78325647 17.4604372,-1.41176471e-05 11.177388,-1.41176471e-05 L10,-1.41176471e-05 L10,7.07568 L10.9203005,7.07568 C14.3163552,7.07568 16.4104918,9.18535059 16.4104918,11.5881741 C16.4104918,13.9914212 14.3163552,16.0866918 10.9203005,16.0866918 L10,16.0866918 L10,24.8245271 L11.0514372,24.8245271 L17.6834262,35.9567153 L25.8464317,35.9567153 L17.1219399,21.1910682 Z",
    id: "Fill-2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4437ab5a04b3257553a0a7b2b1d8d7fe.svg";
export { ForwardRef as ReactComponent };